module.exports = __webpack_public_path__ + "static/assets/fac0198c21aace64a76dac0fb1e5a2a8.png";